import { Injectable } from '@angular/core';
import { AngularFire } from 'angularfire2';
import 'rxjs/add/operator/map';
import { FirebaseService } from './firebase.service';
import { Page, NavItem } from '../models';

@Injectable()
export class NavItemService extends FirebaseService {
  navItems: NavItem[] = [];

  constructor(protected _af: AngularFire) {
    super();
    this.firebaseType = 'nav-items';
  }

  mapObjJson(jsonNavItems: any[]): NavItem[] {
    let navItems = jsonNavItems.map((navItem) => new NavItem(navItem));
    this.navItems.length = 0;
    [].push.apply(this.navItems, navItems);
    this.updateNavItemsWithPages();
    return this.navItems;
  }

  // Called when editing a navItem
  getNavItemByUrl(firebaseUrl: string) {
    return this._af.database.object(this.firebaseRoot + '/nav-items' + firebaseUrl)
    .map(jsonNavItem => {
      jsonNavItem.firebaseUrl = firebaseUrl;
      let navItem = new NavItem(jsonNavItem);
      this.updateNavItemWithPage(navItem);
      return navItem;
    });
  }

  getNavItemObjectByUrl(firebaseUrl: string): NavItem {
    let navItems = this.navItems.slice();
    // Search through root navItems to find the navItem
    for (let i = 0; i < navItems.length; i++) {
      if (navItems[i].firebaseUrl === firebaseUrl) return navItems[i];
    }
    return null;
  }

  // Called when pages or nav items are updated
  updateNavItemsWithPages(pages?: Page[]) {
    if (!pages) pages = this.pages;
    this.pages = pages;
    this.navItems.forEach(navItem => {
      this.updateNavItemWithPage(navItem);
    });
  }

  updateNavItemWithPage(navItem: NavItem) {
    let page = this.pages.filter(page => page.id === navItem.targetID);
    if (page.length) navItem.targetPage = page[0];
    else navItem.targetPage = null;
  }

  updateNavItemsWithDeletedPage(deletedPage: Page) {
    let navItems = this.navItems.slice();
    let firebaseList = [];
    navItems.forEach(navItem => {
      if (navItem.targetID && navItem.targetID.toString() === deletedPage.id) {
        navItem.targetID = null;
      }
      firebaseList.push(navItem.toFirebaseObject());
    });
    return this._af.database.object(this.firebaseRoot).update({ 'nav-items' : firebaseList });
  }

  updateNavItemPositions(childUrl: string, newPosition: number) {
    let navItems = this.navItems.slice();
    let child = this.getNavItemObjectByUrl(childUrl);

    navItems.splice(navItems.indexOf(child), 1);
    navItems.splice(newPosition, 0, child);

    let firebaseList = [];
    for (let i = 0; i < navItems.length; i++) {
      firebaseList.push(navItems[i].toFirebaseObject());
    }
    return this._af.database.object(this.firebaseRoot).update({ 'nav-items' : firebaseList });
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/helpers/nav-items.service.ts